import React from 'react';
import { IconProps } from '.';

const SvgCartFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M9.05 18.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM16.05 18.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM4.272 3.75A1.75 1.75 0 0 1 6.01 5.309l.16 1.441h13.542a1.75 1.75 0 0 1 1.68 2.244l-2.06 7a1.75 1.75 0 0 1-1.678 1.256H7.386a1.75 1.75 0 0 1-1.74-1.559L4.522 5.473a.25.25 0 0 0-.25-.223H1.05a.75.75 0 0 1 0-1.5h3.222Z'
      />
    </svg>
  );
};

export default SvgCartFillRounded;
